import { combineReducers } from 'redux'

import { makeFilterReducer } from '../filter/reducer'
import { FilterReportType } from '../filter/types'

const reducer = combineReducers({ filters: makeFilterReducer(FilterReportType.Dashboard) })

export default reducer
